<template>
  <v-checkbox
    v-model="selected"
    v-on:click.stop="toggleItemSelection"
    hide-details
    class="pod-select-checkbox"
    density="compact"
    :aria-label="$t('routes.node.a11y.selectFile', { name: pod.name })"
  />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js'
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js'

export default {
  name: "PodItemSelect",
  props: {
    pod: {
      type: Object,
      required: true,
    },
    isDeleted: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  emits: ['toggleItemSelection'],
  data: function() {
    return {
      selected: false,
    };
  },
  mounted: function() {
    this.selected = this.isSelected;
  },
  methods: {
    toggleItemSelection: function(ev) {
      this.$emit('toggleItemSelection', ev.shiftKey);
    },
  },
  watch: {
    isSelected: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selected = newValue;
      }
    }
  },
  computed: {
    isSelected: function() {
      const podStore = usePodStore();
      let selectedPods = podStore.getSelectedPods;

      if (this.isDeleted) {
        const recycleBinStore = useRecycleBinStore();
        selectedPods = recycleBinStore.getSelectedPods;
      }

      return selectedPods.indexOf(this.pod) >= 0;
    }
  },
}
</script>

<style lang="scss">
.pod-select-checkbox {
  margin: 0;
  padding: 0;

  :deep(.v-selection-control) {
    align-items: center;
    min-height: 0;
    width: 25px;
    height: 25px;
  }
}

.pod-select-checkbox .v-selection-control--dirty .v-icon {
  color: var(--v-theme-primary) !important;
}

.v-theme--light .pod-select-checkbox .v-icon {
  color: rgba(0, 0, 0, 0.7) ;
}

.v-theme--dark .pod-select-checkbox .v-icon {
  color: rgba(255, 255, 255, 0.7) ;
}
</style>
